import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "./Logo";

/**
 * Slim header used on standalone auth pages (Entrar, Registar, AdminLogin).
 * Provides logo + "back to site" link so users aren't trapped in the form.
 */
export default function AuthHeader({ variant = "light", testId = "auth-header" }) {
    const isDark = variant === "dark";
    return (
        <div
            data-testid={testId}
            className={
                "absolute inset-x-0 top-0 z-10 border-b " +
                (isDark
                    ? "border-white/10 bg-transparent"
                    : "border-border bg-white/80 backdrop-blur-md")
            }
        >
            <div className="container-x flex h-16 items-center justify-between">
                <Logo testId={`${testId}-logo`} size="md" variant={isDark ? "white" : "default"} />
                <Link
                    to="/"
                    data-testid={`${testId}-back`}
                    className={
                        "inline-flex items-center gap-2 rounded-md px-3.5 py-2 text-sm font-semibold transition " +
                        (isDark
                            ? "border border-white/20 text-white hover:bg-white/10"
                            : "border border-primary/15 bg-white text-primary hover:bg-muted")
                    }
                >
                    <ArrowLeft className="h-4 w-4" /> Voltar ao site
                </Link>
            </div>
        </div>
    );
}
